import { getHeadersWithToken } from '@/utils/http'

export const api = {
  async acquireOrderLock(id, force = false) {
    const endpoint = route('api.orders.lock.store', { id })

    const resp = await fetch(endpoint, {
      method: 'POST',
      headers: getHeadersWithToken(),
      body: JSON.stringify({ force })
    })

    if (!resp.ok && resp.status !== 423) {
      throw new Error('Failed to obtain lock')
    }

    const json = await resp.json()

    return [resp.status, json]
  },

  async releaseOrderLock(id) {
    const endpoint = route('api.orders.lock.store', { id })

    const resp = await fetch(endpoint, {
      method: 'DELETE',
      headers: getHeadersWithToken()
    })

    if (resp.status !== 204) {
      throw new Error('Failed to release lock')
    }

    return [resp.status, {}]
  }
}
